import { RootPaths } from "@src/appV2/App/paths";

export const TAX_INFORMATION_PATH = "tax-information";

export const TAX_INFORMATION_FULL_PATH = `${RootPaths.APP_V2_HOME}/accounts/${TAX_INFORMATION_PATH}`;
